import { render } from "./FishHeader.vue?vue&type=template&id=4442400c"
import script from "./FishHeader.vue?vue&type=script&lang=js"
export * from "./FishHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__